
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.233a6.767 6.767 0 110 13.534A6.767 6.767 0 018 1.233zm0 1.412a5.355 5.355 0 100 10.71 5.355 5.355 0 000-10.71zm0 1.013c.364 0 .664.275.702.629l.004.077v3.343l1.611 1.612c.234.233.27.59.108.86l-.049.072-.059.066a.706.706 0 01-.932.06l-.066-.06L7.5 8.5a.706.706 0 01-.203-.42L7.294 8V4.364c0-.39.316-.706.706-.706z"}})])
          )
        }
      }
    